/**
 * NavigationRegion3D parser: Node3D plus the navigation_mesh reference.
 */
import { parseNode3D } from '../../base/node3d/parser';
export function parseNavigationRegion3D(heading, properties) {
    const baseProperties = parseNode3D(heading, properties);
    return {
        ...baseProperties,
        navigationMesh: properties.navigation_mesh,
    };
}
//# sourceMappingURL=parser.js.map